import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Divider from '@mui/material/Divider';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import "./notification.css";
import Authapi from "../Services/Authapi";
import ls from "local-storage";
import swal from "sweetalert";
import { createSwalLoaderNode } from "./swalLoader";
// import Grid from "@material-ui/core/Grid";
import Switch from '@material-ui/core/Switch';
import Tooltip from "@material-ui/core/Tooltip";
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as GiIcons from 'react-icons/gi';
import { ThemeContext } from '../../ThemeContext';
// import * as AiIcons from 'react-icons/ai';
// import * as BiIcons from "react-icons/bi";
// import * as RiIcons from "react-icons/ri";
// import * as CgIcons from "react-icons/cg";
// import * as BsIcons from "react-icons/bs";
// import * as FiIcons from "react-icons/fi";
// import * as IoIcons from "react-icons/io5";
// import * as HiIcons from "react-icons/hi";
// import * as GrIcons from "react-icons/gr";
// import * as DiIcons from "react-icons/di";
import ClearAllIcon from '@mui/icons-material/ClearAll';

const allIcons = {
  ...FaIcons,
  ...MdIcons,
  ...GiIcons,
  // ...AiIcons,
  // ...BiIcons,
  // ...RiIcons,
  // ...CgIcons,
  // ...BsIcons,
  // ...FiIcons,
  // ...IoIcons,
  // ...HiIcons,
  // ...GrIcons,
  // ...DiIcons, 
  // Add more icon packs here if needed
};
const notificationHeaderBlue = "#036dda";
const iconStyle = { color: notificationHeaderBlue, marginRight: '8px' };

const defaultIcons = {
  "Leave Ticket": <i className="fas fa-ticket-alt" style={iconStyle}></i>,
  "Birthday": <i className="fas fa-birthday-cake" style={iconStyle}></i>,
  "Leave Status": <i className="fas fa-ticket-alt" style={iconStyle}></i>,
  "Upcoming Event": <i className="fa fa-arrow-right" style={iconStyle}></i>,
  "Resign-Letter": <i className="fa fa-sign-out" style={iconStyle}></i>,
  "Salary-Slip": <i className="fas fa-balance-scale" style={iconStyle}></i>,
  "Time-Entry": <i className="far fa-times-circle" style={iconStyle}></i>,
  "New Holiday": <i className="fas fa-sign-out-alt" style={iconStyle}></i>,
  "Time-Entry Status": <i className="far fa-times-circle" style={iconStyle}></i>,
  "Task Update": <i className="fas fa-clipboard-list" style={iconStyle}></i>,
  "New Task": <i className="fas fa-tasks" style={iconStyle}></i>,
  "Meeting": <i className="fas fa-calendar-alt" style={iconStyle}></i>,
  "Meeting Notification": <i className="fas fa-calendar-alt" style={iconStyle}></i>,
};

function notificationsLabel(count) {
  if (count === 0) {
    return "no notifications";
  }
  if (count > 99) {
    return "more than 99 notifications";
  }
  return `${count} notifications`;
}

function formatDate(dateString) {
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata"
  };
  return new Intl.DateTimeFormat("en-GB", options).format(new Date(dateString)).replace(/\//g, '-');
}

const NotificationComponent = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notifications, setNotifications] = useState({});
  const [loading, setLoading] = useState(false);
  const [badgeCount, setBadgeCount] = useState(() => {
    try {
      return parseInt(localStorage.getItem('notification_count') || '0', 10);
    } catch (e) {
      return 0;
    }
  });
  const [expandedGroups, setExpandedGroups] = useState({});
  const [notificationIcons, setNotificationIcons] = useState({});
  const [switchState, setSwitchState] = useState(() => {
    const savedStatus = ls.get('notificationStatus');
    return savedStatus !== null ? savedStatus === 1 : props.authUser?.user?.Notification_Status === 1;
  });
  const history = useHistory();
  const User = ls("user");
  const hasFetchedInitialCountRef = React.useRef(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    fetchData(true);
  };

  // console.log(props.authUser.user?.id)

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (window.Notification && window.Notification.permission !== "granted") {
      window.Notification.requestPermission();
    }

    const handleCustomNotification = (e) => {
      if (e && e.detail) {
        const { title, message, type, targetUserIds, target_user_ids, includesAdmin } = e.detail;
        const targets = targetUserIds || target_user_ids;
        // Untyped reminder events must not be stored as meeting notifications.
        if (!type && !Array.isArray(targets) && !includesAdmin) return;

        const currentUserObj = ls("user") || {};
        const currentUserId = currentUserObj.id || currentUserObj.Id;
        const currentRole = ls("roles");
        const isAdmin = currentRole === "Super Admin" || currentRole === "Admin";

        // Exclude creator/updater/deleter or action actor from receiving self-notification
        if (e.detail.actorId && String(e.detail.actorId) === String(currentUserId)) {
          return;
        }

        const notifType = type || title || "Meeting Notification";
        const msgStr = String(message || title || "").trim();

        // Time-Entry Status / approval notifications are for employees, not admins
        if (isAdmin && (notifType === "Time-Entry Status" || /^your time entry was/i.test(msgStr))) {
          return;
        }

        if (Array.isArray(targets) && targets.length > 0) {
          const isTargetedUser = targets.some((id) => {
            const numericId = typeof id === "object" && id !== null ? (id.value ?? id.id) : id;
            return String(numericId) === String(currentUserId);
          });
          if (!isTargetedUser && !(includesAdmin && isAdmin)) return;
        }

        if (notifType === "Meeting Notification") {
          try {
            const storeStr = localStorage.getItem("cherrypik_meeting_notifications_store");
            const storeArr = storeStr ? JSON.parse(storeStr) : [];
            storeArr.unshift({
              id: "meeting_notif_" + Date.now(),
              title: title || "Meeting Notification",
              message: message || title,
              type: "Meeting Notification",
              targetUserIds: targets,
              includesAdmin: Boolean(includesAdmin),
              created_at: new Date().toISOString(),
            });
            localStorage.setItem("cherrypik_meeting_notifications_store", JSON.stringify(storeArr.slice(0, 100)));
          } catch (err) {
            // ignore
          }
        }

        const toastTitle = "Meeting Notification";
        const toastMsg = message || title || "Meeting updated";

        try {
          if (typeof window !== "undefined" && "Notification" in window) {
            let perm = window.Notification.permission;
            if (perm === "default") {
              window.Notification.requestPermission().then((p) => {
                if (p === "granted") {
                  try {
                    const notif = new window.Notification(toastTitle, {
                      body: toastMsg,
                      icon: window.location.origin + "/logo.png",
                      requireInteraction: true,
                      tag: "meeting_notif_" + Date.now(),
                    });
                    notif.onclick = () => { try { window.focus(); notif.close(); } catch (e) {} };
                  } catch (e) {}
                }
              });
            } else if (perm === "granted") {
              try {
                const notif = new window.Notification(toastTitle, {
                  body: toastMsg,
                  icon: window.location.origin + "/logo.png",
                  requireInteraction: true,
                  tag: "meeting_notif_" + Date.now(),
                });
                notif.onclick = () => { try { window.focus(); notif.close(); } catch (e) {} };
                setTimeout(() => { try { notif.close(); } catch (e) {} }, 8000);
              } catch (e) {
                if ("serviceWorker" in navigator) {
                  navigator.serviceWorker.getRegistration().then(reg => {
                    if (reg && reg.showNotification) {
                      reg.showNotification(toastTitle, { body: toastMsg, icon: window.location.origin + "/logo.png" });
                    }
                  });
                }
              }
            }
          }
        } catch (e) {
          // ignore
        }

        setNotifications((prev) => {
          const prevList = (prev && prev[notifType]) || [];
          const newMsg = message || title;
          const newMsgNorm = String(newMsg || "").trim().toLowerCase();
          const nowStr = formatDate(new Date());

          const isDuplicate = prevList.some((item) => {
            const itemMsgNorm = String(item.notification || "").trim().toLowerCase();
            const itemTimeStr = formatDate(item.created_at);
            return itemMsgNorm === newMsgNorm && itemTimeStr === nowStr;
          });

          if (isDuplicate) return prev;

          const newNotif = {
            id: "local_" + Date.now(),
            notification: newMsg,
            type: notifType,
            created_at: new Date().toISOString(),
            is_view: 1,
            is_read: 0,
          };
          return {
            ...(prev || {}),
            [notifType]: [newNotif, ...prevList],
          };
        });
      }
    };

    const handleRefreshNotifications = () => {
      fetchData(false);
    };

    window.addEventListener("cherrypik_new_notification", handleCustomNotification);
    window.addEventListener("cherrypik_refresh_notifications", handleRefreshNotifications);

    // Do not fetch notifications on mount to keep initial page load fast and clean.
    // Full notifications will load on-demand when user clicks the notification bell.
    hasFetchedInitialCountRef.current = true;

    return () => {
      window.removeEventListener("cherrypik_new_notification", handleCustomNotification);
      window.removeEventListener("cherrypik_refresh_notifications", handleRefreshNotifications);
    };
  }, []);

  useEffect(() => {
    const currentStatus = props.authUser?.user?.Notification_Status;
    if (currentStatus !== undefined) {
      setSwitchState(currentStatus === 1);
      ls.set('notificationStatus', currentStatus);
    }
  }, [props.authUser?.user?.Notification_Status]);

  const fetchData = async (isFullFetch = false) => {
    const path = (typeof window !== "undefined" ? window.location.pathname : "").toLowerCase();
    const isAuthRoute =
      path.includes("/login") ||
      path.includes("/forgotpassword") ||
      path.includes("/forgot-password") ||
      path.includes("/resetpassword") ||
      path.includes("/reset-password");
    if (isAuthRoute) return;

    const user = ls("user");
    const authToken = ls("authToken");
    if (!user || !authToken) return;

    if (isFullFetch) {
      setLoading(true);
    }

    try {
      let notificationsData = ls("roles") === "Super Admin"
        ? await Authapi.Notification()
        : await Authapi.NotificationEmployee();

      if (notificationsData && typeof notificationsData === "object") {
        const filtered = {};
        Object.keys(notificationsData).forEach((type) => {
          const seenKeys = new Set();
          const list = (notificationsData[type] || []).filter((item) => {
            const msg = String(item.notification || "").toLowerCase();
            if (msg.includes("a new calendar event")) return false;

            const notifMsg = String(item.notification || "").trim().toLowerCase();
            const notifType = String(item.type || type || "").trim().toLowerCase();
            const notifDataId = item.data_id !== undefined && item.data_id !== null ? String(item.data_id) : "";
            const displayTime = formatDate(item.created_at);
            const uniqueKey = `${notifType}_${notifMsg}_${notifDataId}_${displayTime}`;

            if (seenKeys.has(uniqueKey)) return false;
            seenKeys.add(uniqueKey);
            return true;
          });
          if (list.length > 0) {
            filtered[type] = list;
          }
        });
        notificationsData = filtered;
      } else {
        notificationsData = {};
      }

      const totalCount = Object.keys(notificationsData).flatMap(key => notificationsData[key]).length;
      setBadgeCount(totalCount);
      try {
        localStorage.setItem("notification_count", totalCount.toString());
      } catch (e) {}

      // If this is just on-mount count checking, stop here to avoid unnecessary calls and freezes
      if (!isFullFetch) {
        return;
      }

      try {
        const storeStr = localStorage.getItem("cherrypik_meeting_notifications_store");
        if (storeStr) {
          const storeArr = JSON.parse(storeStr);
          const currentUserObj = ls("user") || {};
          const currentUserId = currentUserObj.id || currentUserObj.Id;
          const currentRole = ls("roles");
          const isAdmin = currentRole === "Super Admin" || currentRole === "Admin";

          const meetingStoreArr = storeArr.filter((item) => {
            const msg = String(item.message || item.title || "").trim();
            const itemType = item.type || "";
            if (/^leave reminder:/i.test(msg) || /^your time entry was/i.test(msg)) return false;
            if (itemType && itemType !== "Meeting Notification") return false;
            return true;
          });
          if (meetingStoreArr.length !== storeArr.length) {
            localStorage.setItem("cherrypik_meeting_notifications_store", JSON.stringify(meetingStoreArr));
          }

          const userMeetingNotifs = meetingStoreArr.filter((item) => {
            const targets = item.targetUserIds;
            if (!Array.isArray(targets) || targets.length === 0) return true;
            const isTarget = targets.some((id) => String(typeof id === "object" && id !== null ? (id.value ?? id.id) : id) === String(currentUserId));
            if (isTarget) return true;
            if (item.includesAdmin && isAdmin) return true;
            return false;
          }).map(item => ({
            id: item.id,
            notification: item.message || item.title,
            type: "Meeting Notification",
            created_at: item.created_at,
            is_view: 1,
            is_read: 0,
          }));

          if (userMeetingNotifs.length > 0) {
            const existingMeetingNotifs = notificationsData["Meeting Notification"] || [];
            const combined = [...userMeetingNotifs, ...existingMeetingNotifs];
            const uniqueMeetingNotifs = [];
            const seen = new Set();
            combined.forEach(n => {
              const k = `${n.notification}_${formatDate(n.created_at)}`;
              if (!seen.has(k)) {
                seen.add(k);
                uniqueMeetingNotifs.push(n);
              }
            });
            notificationsData["Meeting Notification"] = uniqueMeetingNotifs;
          }
        }
      } catch (err) {
        // ignore
      }

      setNotifications(notificationsData);

      const initialExpandedGroups = {};
      Object.keys(notificationsData).forEach(type => {
        initialExpandedGroups[type] = true;
      });
      setExpandedGroups(initialExpandedGroups);
      const iconsResponse = await Authapi.getNotificationIcons();
      if (iconsResponse) {
        const transformedIcons = {};
        Object.keys(iconsResponse).forEach(key => {
          transformedIcons[key.replace(/_/g, ' ')] = iconsResponse[key];
        });
        setNotificationIcons(transformedIcons);
      }
      if (notificationsData) {
        Object.keys(notificationsData).forEach(type => {
          notificationsData[type].forEach(async notification => {
            if (notification.is_view === 0) {
              const notifType = String(notification.type || type || "").toLowerCase();
              const isCalendarOrEventNotif = notifType.includes("event") || notifType.includes("meeting") || notifType.includes("calendar");

              const notifStatus = props.authUser?.user?.Notification_Status ?? ls.get('notificationStatus') ?? 1;
              if (!isCalendarOrEventNotif && (notifStatus == 1 || notifStatus === true)) {
                showDesktopNotification(notification);
              }
              await Authapi.Notificationview(notification.id);
            }
          });
        });
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      if (isFullFetch) {
        setLoading(false);
      }
    }
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = async (notification) => {
    try {
      await Authapi.Notificationread(notification.id);
      const notificationData = { id: notification.id, type: notification.type, dataId: notification.data_id };
      sessionStorage.setItem('fromNotificationPanel', 'true');

      switch (notification.type) {
        case "Leave Ticket":
        case "Leave Status":
          history.push({
            pathname: "/leave-tickets",
            state: { notificationData }
          });
          break;
        case "Time-Entry":
        case "Time-Entry Status":
          history.push({
            pathname: "/time-entries",
            state: { notificationData }
          });
          break;
        case "Upcoming Event":
          const eventId = notification.data_id;
          sessionStorage.setItem('openEventModal', 'true');
          history.push({
            pathname: "/dashboard",
            state: { eventId }
          });
          break;
        case "New Holiday":
          const dateMatch = notification.notification.match(/\d{2}-\d{2}-\d{4}/);
          if (dateMatch) {
            const date = dateMatch[0];
            sessionStorage.setItem('openHolidayModal', 'true');
            history.push({
              pathname: "/holiday-leaves",
              state: { date }
            });
          }
          break;
        case "Resign-Letter":
          history.push("/Relievingletter");
          break;
        case "Birthday":
          history.push("/dashboard");
          break;
        case "Salary-Slip":
          const salarySlipPath =
            ls("roles") === "Super Admin"
              ? `/users/${notification.user_id}`
              : "/profile";
          sessionStorage.setItem('openSalaryModal', 'true');
          history.push({
            pathname: salarySlipPath,
            state: { tab: "salaryInfo", salarySlipId: notification.data_id }
          });
          break;
        case "Task Update":
        case "New Task":
          history.push({
            pathname: "/tasks",
            // state: { taskId: notification.data_id }
          });
          break;
        case "Project Activity":
        case "Projectactivity":
        case "Project-Activity":
        case "project activity":
        case "project_activity":
          // Open specific project details; data_id expected to be project id
          if (notification.data_id) {
            history.push({
              pathname: `/project/${notification.data_id}`,
            });
          } else {
            history.push({ pathname: "/project" });
          }
          break;
        case "Issue Activity":
        case "Issueactivity":
        case "Issue-Activity":
        case "issue activity":
        case "issue_activity":
          // Parse data_id JSON to get project_id and issue_id
          try {
            const dataIdObj = typeof notification.data_id === 'string' 
              ? JSON.parse(notification.data_id) 
              : notification.data_id;
            
            if (dataIdObj && dataIdObj.project_id && dataIdObj.issue_id) {
              history.push({
                pathname: `/project/${dataIdObj.project_id}`,
                state: { tab: 'issues', openIssueId: dataIdObj.issue_id }
              });
            } else {
              // Fallback: go to project list if parsing fails
              history.push({ pathname: "/project" });
            }
          } catch (error) {
            console.error("Error parsing notification data_id:", error);
            // Fallback: go to project list if parsing fails
            history.push({ pathname: "/project" });
          }
          break;
        default:
          break;
      }
      handleClose();
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleExpandClick = (type) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const renderNotificationsByType = (type, darkMode) => {
    return notifications[type].map((notification, index) => (
      <Card
        key={notification.id}
        onClick={() => handleNotificationClick(notification)}
        style={{
          marginBottom: '6px',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
          position: 'relative',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          borderRadius: '6px'
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = darkMode ? '#2a2a2a' : '#f5f7fa'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = darkMode ? '#1e1e1e' : 'white'}
      >
        <CardContent style={{ padding: '8px 12px 22px' }}>
          <Typography variant="caption" component="p" style={{ color: darkMode ? '#ffffff' : '#2d3748', fontSize: '0.8rem', lineHeight: 1.45, wordBreak: 'break-word' }}>
            {index + 1}. {notification.notification}
          </Typography>
          <Typography 
            variant="caption" 
            style={{ 
              position: 'absolute', 
              bottom: '4px', 
              right: '10px',
              fontSize: '0.68rem',
              color: darkMode ? notificationHeaderBlue : 'rgba(0, 0, 0, 0.45)'
            }}
          >
            {formatDate(notification.created_at)}
          </Typography>
        </CardContent>
      </Card>
    ));
  };

  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];
  const showDesktopNotification = (notification) => {
    if (typeof window === "undefined" || !("Notification" in window)) return;

    const notifType = notification.type || "New Notification";
    const notifMsg = notification.notification || "You have a new update";
    const title = notifType.includes("Task") ? `Task - ${notifType}` : notifType;

    const fireNotification = () => {
      try {
        const desktopNotif = new window.Notification(title, {
          body: notifMsg,
          icon: window.location.origin + "/logo.png",
          requireInteraction: true,
          tag: "ems_notif_" + (notification.id || Date.now()),
        });
        desktopNotif.onclick = () => {
          try {
            window.focus();
            desktopNotif.close();
            if (notifType.toLowerCase().includes("task")) {
              history.push({ pathname: "/tasks" });
            } else {
              history.push({ pathname: "/detailed-notifications" });
            }
          } catch (e) {}
        };
        setTimeout(() => {
          try { desktopNotif.close(); } catch (e) {}
        }, 12000);
      } catch (err) {
        if ("serviceWorker" in navigator) {
          navigator.serviceWorker.getRegistration().then((reg) => {
            if (reg && reg.showNotification) {
              reg.showNotification(title, {
                body: notifMsg,
                icon: window.location.origin + "/logo.png",
              });
            }
          });
        }
      }
    };

    if (window.Notification.permission === "granted") {
      fireNotification();
    } else if (window.Notification.permission === "default") {
      window.Notification.requestPermission().then((perm) => {
        if (perm === "granted") {
          fireNotification();
        }
      });
    }
  };

  const handleMarkAllAsRead = async () => {
    if (ls("roles") === "Super Admin") {
      try {
        const willProceed = await swal({
          title: "Are you sure?",
          text: "Do you want to mark all notifications as read?",
          icon: "warning",
          buttons: ["Cancel", "Confirm"],
          dangerMode: true,
        });
        if (willProceed) {
          swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          const response = await Authapi.notificationsalladmin();
          try {
            localStorage.removeItem("cherrypik_meeting_notifications_store");
          } catch (e) {}
          setNotifications({});
          fetchData();
          swal("Success", "All notifications marked as read!", "success");
        } else {
          swal("Cancelled", "The action was cancelled.", "info");
        }
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
        swal("Error", "Failed to mark all notifications as read.", "error");
      }
    } else {
      try {
        const willProceed = await swal({
          title: "Are you sure?",
          text: "Do you want to mark all notifications as read?",
          icon: "warning",
          buttons: ["Cancel", "Confirm"],
          dangerMode: true,
        });
        if (willProceed) {
          swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          const response = await Authapi.notificationsallemployee();
          try {
            localStorage.removeItem("cherrypik_meeting_notifications_store");
          } catch (e) {}
          setNotifications({});
          fetchData();
          swal("Success", "All notifications marked as read!", "success");
        } else {
          swal("Cancelled", "The action was cancelled.", "info");
        }
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
        swal("Error", "Failed to mark all notifications as read.", "error");
      }
    }
  }

  const statusRow = async (id, status) => {
    const confirm = await swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    });
    if (confirm) {
      swal({
        title: "Loading",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: createSwalLoaderNode(),
      });
      try {
        let statu = await Authapi.NotificationStatus(id, status);
        swal.close();
        if (statu && statu.status === true) {
          setSwitchState(status === 1);
          ls.set('notificationStatus', status);
          if (props.userData) {
            await props.userData();
          }
          // Refresh the page to ensure all states are in sync
          window.location.reload();
        }
      } catch (error) {
        console.error('Error updating user status:', error);
        swal("Error", "Failed to update notification status", "error");
      }
    }
  }

  return (
    <ThemeContext.Consumer>
      {({ darkMode }) => (
    <div>
  <IconButton
  aria-describedby={id}
  aria-label={notificationsLabel(badgeCount)}
  className="notification-icon-button"
  style={{
    position: "absolute",
    right: "56px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "white",
    padding: "6px",
    width: "36px",
    height: "36px",
    overflow: "visible",
    borderRadius: "50%",
  }}
  onClick={handleClick}
>
  <Badge 
    badgeContent={badgeCount} 
    color="info"
    className="notification-count-badge"
    overlap="circular"
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
  >
    <NotificationsIcon htmlColor="#ffffff" />  
  </Badge>
</IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            // padding: 2,
            borderRadius: 10,
          },
        }}
        disableScrollLock
      >
        <div
          style={{
            padding: '10px 14px',
            background: `linear-gradient(180deg, var(--hrms-primary-blue-start, ${notificationHeaderBlue}) 0%, var(--hrms-primary-blue-end, ${notificationHeaderBlue}) 100%)`,
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <NotificationsActiveIcon style={{ marginRight: '8px', fontSize: '1.2rem' }} />
            <Typography variant="subtitle2" style={{ margin: 0, fontWeight: 700, fontSize: '0.9rem' }}>
              Notifications
            </Typography>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Tooltip title={switchState ? "Notification Off" : "Notification On"}>
              <label
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  margin: 0,
                  cursor: 'pointer'
                }}
              >
                <Switch
                  size="small"
                  onClick={(e) => statusRow(props.authUser.user?.id, switchState ? 0 : 1)}
                  checked={switchState} />
              </label>
            </Tooltip>
            <IconButton
              onClick={() => handleMarkAllAsRead()}
              size="small"
              style={{
                color: "#ffffff",  
                padding: '4px'
              }}
              title="Clear Notifications"
            >
              <ClearAllIcon htmlColor="#ffffff" style={{ fontSize: '1.2rem' }} />  
            </IconButton>
          </div>
        </div>
        <Divider />
        <Typography sx={{ p: 1 }} style={{ height: "440px", width: "380px", overflowY: "auto" }}>
          {loading ? (
            <p style={{ fontSize: '0.82rem', margin: '8px 0' }}>Loading...</p>
          ) : (
            Object.keys(notifications).length > 0 ? (
              Object.keys(notifications).map((type) => (
                <div key={type}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 2px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {allIcons[notificationIcons[type]]
                        ? React.createElement(allIcons[notificationIcons[type]], { style: { ...iconStyle, fontSize: '0.95rem', marginRight: '6px' } })
                        : defaultIcons[type]}
                      <Typography variant="caption" style={{ margin: 0, fontWeight: 700, fontSize: '0.82rem' }}>
                        {type}
                      </Typography>
                    </div>
                    {Object.keys(notifications).length > 1 && (
                      <IconButton size="small" onClick={() => handleExpandClick(type)} style={{ padding: '2px' }}>
                        {expandedGroups[type] ? <ExpandLessIcon style={{ fontSize: '1.1rem' }} /> : <ExpandMoreIcon style={{ fontSize: '1.1rem' }} />}
                      </IconButton>
                    )}
                  </div>
                  {expandedGroups[type] && renderNotificationsByType(type, darkMode)}
                  <Divider style={{ margin: '4px 0' }} />
                </div>
              ))
            ) : (
              <p style={{ fontSize: '0.82rem', margin: '8px 0', textAlign: 'center', color: '#888' }}>No notifications available</p>
            )
          )}
        </Typography>
        <Divider />
        {userpermissions.includes("DetailedNotifications.Show") && (
          <div style={{ padding: '8px 12px', textAlign: 'center' }}>
            <Link to="/detailed-notifications" style={{ textDecoration: 'none' }}>
              <Typography
                variant="caption"
                style={{
                  color: notificationHeaderBlue,
                  fontWeight: 700,
                  fontSize: '0.78rem',
                  letterSpacing: '0.05em'
                }}
              >
                SHOW ALL NOTIFICATIONS
              </Typography>
            </Link>
          </div>
        )}
      </Popover>
    </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default NotificationComponent;

